Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var buttonContainer = {
    width: '100%',
    maxWidth: _styles.STYLES.grid.maxInputWidth,
    minWidth: (0, _styles.getREM)(16),
    alignSelf: 'center'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    buttonContainer.minWidth = '100%';
  }
  if (bp.is([bp.mobile_l])) {
    buttonContainer.minWidth = (0, _styles.getREM)(18);
  }
  if (bp.is([bp.mobile_xl, bp.tablet, bp.desktop])) {
    buttonContainer.minWidth = (0, _styles.getREM)(22);
  }
  var styles = _reactNative.StyleSheet.create({
    buttonContainer: buttonContainer
  });
  return {
    styles: styles
  };
};